module.exports = __webpack_public_path__ + "static/media/perso-02@2x.fb4a0cab.png";